// extracted by mini-css-extract-plugin
export default {"reportAdTitle":"_3Y8mi","anchorTag":"_4M-Tw","reportEmailLink":"_6P5cd","reportTextWrapper":"_3xNpF"};